import jQuery from "./jQuery-wrapper.js";
import Theme from "./Theme.js";

jQuery($ => {
	const theme = new Theme();
});